import { render, staticRenderFns } from "./DetailSubItemGallery.vue?vue&type=template&id=4c10c376&"
import script from "./DetailSubItemGallery.vue?vue&type=script&lang=js&"
export * from "./DetailSubItemGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports